"use strict";
exports.__esModule = true;
var ChartMeasure_1 = require("./ChartMeasure");
var ChartDimension_1 = require("./ChartDimension");
var ChartDataStructure = /** @class */ (function () {
    function ChartDataStructure(_a) {
        var datasets = _a.datasets, measures = _a.measures, dimensions = _a.dimensions, originalDatasets = _a.originalDatasets, originalMeasures = _a.originalMeasures;
        var _this = this;
        this.toJSON = function () { return ({
            datasets: _this.datasets,
            measures: _this.measures,
            dimensions: _this.dimensions,
            originalDatasets: _this.originalDatasets,
            originalMeasures: _this.originalMeasures
        }); };
        this.datasets = datasets;
        this.measures = measures;
        this.dimensions = dimensions;
        this.originalDatasets = originalDatasets;
        this.originalMeasures = originalMeasures;
    }
    ChartDataStructure.fromJSON = function (json) {
        var _a = Object.assign({}, json), datasets = _a.datasets, measures = _a.measures, dimensions = _a.dimensions, originalDatasets = _a.originalDatasets, originalMeasures = _a.originalMeasures;
        var _datasets = datasets ? datasets.map(function (item) { return ChartMeasure_1["default"].fromJSON(item); }) : undefined;
        if (_datasets === undefined) {
            throw new Error('.datasets must be an array');
        }
        var _measures = measures ? measures.map(function (item) { return ChartMeasure_1["default"].fromJSON(item); }) : undefined;
        var _dimensions = dimensions ? dimensions.map(function (item) { return ChartDimension_1["default"].fromJSON(item); }) : undefined;
        var _originalDatasets = originalDatasets
            ? originalDatasets.map(function (item) { return ChartMeasure_1["default"].fromJSON(item); })
            : undefined;
        var _originalMeasures = originalMeasures
            ? originalMeasures.map(function (item) { return ChartMeasure_1["default"].fromJSON(item); })
            : undefined;
        return new ChartDataStructure({
            datasets: _datasets,
            measures: _measures,
            dimensions: _dimensions,
            originalDatasets: _originalDatasets,
            originalMeasures: _originalMeasures
        });
    };
    return ChartDataStructure;
}());
exports["default"] = ChartDataStructure;
